<template>
	<div :class="{ open: open }" class="cnt-dropdraw">
		<div class="input-group">
			<input
				v-model="search"
				type="text"
				class="form-control"
				:placeholder="!open ? selected_text : ''"
				:title="selected_text"
				@click="open = true"
				@focusout="exit"
			/>
			<div class="input-group-btn">
				<button
					v-if="open == false"
					class="btn btn-default"
					@click="fxOpen"
				>
					<i class="fa fa-search"></i>
				</button>
				<button
					v-else-if="open == false"
					class="btn btn-default"
					@click="fxOpen"
				>
					<i class="fa fa-trash-o"></i>
				</button>
				<button
					v-else-if="open == true"
					class="btn btn-default"
					@click="fxClose(true)"
				>
					<i class="fa fa-check"></i>
				</button>
			</div>
		</div>
		<ul class="dropdown-menu">
			<div v-if="radio === false" class="cnt-buttons">
				<div class="btn-marc" @click="marcar_todos">
					<i class="fa fa-check-square-o"></i>
					Marcar
				</div>
				<div class="btn-marc" @click="desmarcar_todos">
					<i class="fa fa-square-o"></i>
					Desmarcar
				</div>
			</div>
			<div class="cnt-list">
				<li v-for="(option, index) in filter_options" :key="index">
					<label>
						<!-- @click='fxClose()' -->
						<input
							v-if="radio === false"
							v-model="value_input"
							:value="option.val"
							type="checkbox"
						/>
						<input
							v-else
							v-model="value_input"
							:value="option.val"
							type="radio"
						/>
						<span
							class="text"
							:title="option.text"
							v-html="option.text"
						></span>
					</label>
				</li>
				<li class="dont-search" v-if="filter_options.length == 0">
					<a>
						<i class="fa fa-warning"></i>
						Nenhum encontrado!
					</a>
				</li>
			</div>
		</ul>
	</div>
</template>
<script>
	export default {
		name: 'DropDraw',
		props: {
			placeholder: {
				default: 'Pesquisar',
			},
			value: {
				required: true,
			},

			asset: {
				default: [],
				required: true,
				type: Array,
			},
			cod: {
				default: 'cod',
			},
			title: {
				default: 'title',
			},

			radio: {
				default: false,
			},
		},
		data() {
			return {
				search: '',
				open: false,
			};
		},
		methods: {
			desmarcar_todos() {
				this.$emit('input', []);
			},
			marcar_todos() {
				let options = [];

				this.filter_options.forEach((item) => {
					// console.log(item)
					options.push(item.val);
				});
				this.$emit('input', options);
			},
			fxOpen() {
				this.search = '';
				this.open = true;
			},
			exit() {
				// if(this.radio !== false){
				// 	setTimeout(e=> {
				// 		this.open = false
				// 		this.search = ''
				// 	},100)
				// }
			},
			fxClose(force = false) {
				if (force === true) {
					this.open = false;
					this.search = '';
					this.$emit('change');
				}
				// else{
				// 	if(this.radio !== false){
				// 		this.open = false
				// 		this.search = ''
				// 	}
				// }
			},
			get_value(cod) {
				let selected = this.options.find((item) => item.val == cod);
				return selected == undefined ? '' : selected.text;
			},
		},
		computed: {
			options() {
				if (
					(this.asset != null || this.asset != undefined) &&
					Array.isArray(this.asset)
				) {
					let list = [];
					this.asset.forEach((item) => {
						if (typeof item == 'object' && item != null) {
							list.push({
								val: item[this.cod],
								text: item[this.title],
							});
						}
					});
					return list;
				} else {
					return [];
				}
			},
			selected_text() {
				let resp = null;
				if (this.radio === false) {
					let texts = [];
					if (Array.isArray(this.value)) {
						this.value.forEach((item) => {
							let mText = this.get_value(item);
							if (mText != '') texts.push(mText);
						});
						resp = texts.join('; ');
					}
					resp = this.placeholder;
				} else {
					let selected = this.options.find(
						(item) => item.val == this.value
					);
					resp =
						selected == undefined
							? this.placeholder
							: selected.text;
				}

				return resp.replace(/<[^>]*>/g, '');
			},
			filter_options() {
				return this.options.filter(
					(item) =>
						String(item.text)
							.toLowerCase()
							.indexOf(this.search.toLowerCase()) != -1
				);
			},
			value_input: {
				get() {
					return this.value;
				},
				set(val) {
					if (this.radio === false) {
						if (typeof this.value != 'object') {
							this.$emit('input', [val]);
						} else {
							this.$emit('input', val);
						}
					} else {
						this.$emit('input', val);
					}
				},
			},
		},
	};
</script>
<style scoped>
	.dont-search {
		padding: 10px 0 20px;
		text-align: center;
	}
	.cnt-buttons {
		display: block;
		z-index: 300;
		background: #d2d6de;
		width: 100%;
		margin-top: -5px;
		height: 40px;
	}
	.cnt-list {
		display: block;
		width: 100%;
		max-height: 300px;
		overflow: auto;
		padding-top: 12px;
		margin-bottom: -5px;
	}
	.btn-marc {
		float: left;
		padding: 10px 21px;
		cursor: pointer;
	}
	.btn-marc:hover {
		background: #f4f4f4;
	}
	.text {
		display: block;
		font-size: 14px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
	.cnt-dropdraw {
		position: relative;
	}
	.cnt-dropdraw .input-group .input-group-btn {
		max-width: 38px;
	}
	.cnt-dropdraw .dropdown-menu {
		width: calc(100% - 38px);
	}
	.dropdown-menu label input {
		margin: 4px 5px 0 0;
		float: left;
	}
	.form-control::placeholder {
		color: #555;
	}
	.dropdown-menu label {
		display: block;
		padding: 3px 20px;
		clear: both;
		font-weight: 400;
		line-height: 1.42857143;
		color: #777;
		white-space: nowrap;
		cursor: pointer;
	}
	.dropdown-menu label:hover {
		background-color: #e1e3e9;
		color: #333;
	}
</style>



// WEBPACK FOOTER //
// src/app-components/drop-draw.vue